module.exports = __webpack_public_path__ + "img/money.589e34c8.jpg";